<template>
  <q-dialog ref="dialog" persistent>
    <div gap="var(--r-space-xl)" class="dialog bg-white-1 q-pa-xl">
      <div class="text-subtitle-1 text-secondary-1 text-center">
        You are about to mark {{ subsCount }} subscriptions as {{ capitalize(status.name) }}. Are you sure?
      </div>

      <Grid gaf="column" gap="var(--r-space-md)" justify-content="center" class="q-pt-xl">
        <RBtn :disable="loading" type="ghost" @click="onCancel">Cancel</RBtn>
        <RBtn :loading="loading" @click="onConfirm">Yes, mark as {{ status.name }}</RBtn>
      </Grid>
    </div>
  </q-dialog>
</template>

<script>
import * as apiTo from '@/modular-api'
// Libraries
import { mapState } from 'vuex'

export default {
  props: {
    subsCount: {
      type: Number,
      required: true
    },

    status: {
      type: Object,
      required: true
    },

    filterModel: {
      type: Object,
      required: true
    },

    vuexModule: {
      type: String,
      required: true
    }
  },

  data: () => ({
    loading: false
  }),

  computed: {
    ...mapState('predictions', ['financialPeriodId']),

    selectAll() {
      return this.$store.state[this.vuexModule].selectAll
    },

    rowsSelected() {
      return this.$store.state[this.vuexModule].rowsSelected
    },

    selectedDepartment() {
      return this.$store.state[this.vuexModule].selectedDepartment
    }
  },

  methods: {
    show() {
      this.$refs.dialog.show()
    },

    hide() {
      this.$refs.dialog.hide()
    },

    async onConfirm() {
      this.loading = true
      await this.update()
      this.loading = false
      this.$emit('ok')
      this.hide()
    },

    update() {
      const includedOrExcludedIds = this.selectAll ? 'excluded_ids' : 'included_ids'
      const apiName =
        this.vuexModule === 'recommendations'
          ? 'MODIFY_SUB_PERIODS_RECOMMENDATION_STATUS'
          : 'MODIFY_SUB_PERIODS_PROPOSAL_STATUS'
      const statusName = this.vuexModule === 'recommendations' ? 'recommendation_status_id' : 'proposal_status_id'

      return apiTo[apiName]({
        [statusName]: this.status.id,
        [includedOrExcludedIds]: this.rowsSelected.map(row => row.id),
        filter_financial_period_id: this.financialPeriodId,
        filter_department_id: this.selectedDepartment?.id,
        filterModel: this.filterModel
      })
    },

    onCancel() {
      this.hide()
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog {
  width: 394px;
}
</style>
